import request from "@/utils/request";

// 分页查询
export function queryMyInitiativeList(data) {
  return request({
    url: "/act/myStartInstance/list",
    method: "post",
    data,
  });
}

// 获取详情
export function queryMyInitiativeById(instanceId) {
  return request({
    url: `/act/myStartInstance/processInstanceDetail/${instanceId}`,
    method: "get",
  });
}

// 撤回
export function taskCallBack(instanceId) {
  return request({
    url: `/act/myStartInstance/taskCallBack/${instanceId}`,
    method: "get",
  });
}

// 取消(删除)
export function deleteInstanceById(instanceId) {
  return request({
    url: `/act/myStartInstance/deleteInstanceById/${instanceId}`,
    method: "get",
  });
}

export function getBackNodes(instanceId) {
  return request({
    url: `/act/needDealt/getBackNodes/${instanceId}`,
    method: "get",
  });
}

export function startFormInfo(instanceId) {
  return request({
    url: `/act/needDealt/getStartFormInfo/${instanceId}`,
    method: "get",
  });
}

export function taskOperationLog(instanceId) {
  return request({
    url: `/act/needDealt/getTaskOperationLog/${instanceId}`,
    method: "get",
  });
}

export function historyFormData(taskId) {
  return request({
    url: `/act/needDealt/historyFormData/${taskId}`,
    method: "get",
  });
}
